/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchFacetsBh = {
    /**
     * Check if a facet should create BH size facet
     *
     * @param {Object} facet - The facet to check.
     * @returns {boolean} - True if the facet should create BH size facet, false otherwise.
     */
    shouldCreateBhSizeFacet(facet) {
        return facet.attribute === this.facetConfig.mergedBhAttribute;
    },
    /**
     * Create BH size facet
     *
     * @param {Object} facet - The facet to create.
     * @returns {Object} - The created BH size facet.
     */
    createBhSizeFacet(facet) {
        const bhSizeFacets = facet.options.map(option => this.createMappedFacet(option));
        return {
            name: facet.name,
            attribute: facet.attribute,
            options: bhSizeFacets
        };
    },
    /**
     * Check if facet is bh or cup size
     *
     * @param attribute
     * @returns {boolean}
     */
    isBhOrCupSizeFacet(attribute) {
        return this.facetConfig.bhAttributes.includes(attribute);
    },
    /**
     * Disable unavailable BH size options
     *
     * @param {Object} facet - The facet to update.
     * @param {Object} currentFacet - The current facet to compare against.
     */
    disableUnavailableBhSizeOptions(facet, currentFacet) {
        facet.options.forEach((item, index) => {
            if (currentFacet.options[index] && currentFacet.options[index].buckets) {
                item.options.forEach(option => {
                    option.disabled = !currentFacet.options[index].buckets.some(bucket => bucket.title === option.label);
                });
            }
        });
    },
}

export default liveSearchFacetsBh;
